import PropTypes from 'prop-types';
import CompetitorIconImpl from './competitor-icon.js';
import MojitoCore from 'mojito/core';

/**
 * Competitor icon component. It is used to display the competitor icon based on team id.
 *
 * @class CompetitorIcon
 * @memberof Mojito.Presentation.Components
 */

/**
 * CompetitorIcon prop types.
 *
 * @property {string} [title] - String or string key that, if present, will be used as a title for the image element.
 * @property {string} src - Icon src. Possible formats: encoded base 64 svg string, data URL.
 *
 * @memberof Mojito.Presentation.Components.CompetitorIcon
 */
const propTypes = {
    title: PropTypes.string,
    src: PropTypes.string,
};

export default MojitoCore.Presentation.UIView('CompetitorIcon', CompetitorIconImpl, propTypes);
